import React from 'react';
import { styled } from '../../../stitches.config';
import Html from './Html';

import { withDrawingBoard } from "../../HOCs/withDrawingBoard"

const Collage = ({ collage }) => {
    const { url1, url2, url3, description } = collage;
    return (
        <CollageWrapper>
            <div>
                <Img css={{ "$$src": `url("${url1}")` }} />
                <Img css={{ "$$src": `url("${url2}")` }} />
                <Img css={{ "$$src": `url("${url3}")` }} />
            </div>
            <Html html={description} />
        </CollageWrapper>
    )
}

const CollageWrapper = styled("div", {
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-around",
    "&>div:first-of-type": {
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-between",
        minHeight: "350px",
        "&>div": {
            "&:nth-of-type(1)": {
                alignSelf: "center"
            },
            "&:nth-of-type(2)": {
                alignSelf: "flex-start"
            },
            "&:nth-of-type(3)": {
                alignSelf: "flex-end"
            }
        }
    },
    "&>div:nth-of-type(2)": {
        margin: "20px 38px",
        lineHeight: "23px",
        color: "#262626",
        fontSize: "17px",
        fontWeight: 300,
        letterSpacing: "-0.34px"
    },
    "@media (min-width: 992px)": {
        margin: "85px 6%",
        flexDirection: "row",
        "&>div:first-of-type": {
            height: "500px",
            minWidth: "700px"
        },
        "&>div:nth-of-type(2)": {
            alignSelf: "center",
            width: "469px",
            color: "#222222",
            fontSize: "18px",
            fontWeight: 400,
            letterSpacing: "-0.3px",
            lineHeight: "28px"
        }
    }
});

const Img = styled("div", {
    height: "250px",
    width: "30%",
    backgroundImage: "$$src",
    backgroundSize: "cover",
    backgroundRepeat: "no-reapeat",
    backgroundPosition: "50% 50%",
    "@media (min-width: 992px)": {
        height: "402px",
        width: "222px"
    }
});

export default withDrawingBoard(props => props.collage.hasCanvas)(Collage);